import { useEffect, useState } from "react";
import {
  GoabButton,
  GoabSpacer,
  GoabPageBlock,
} from "@abgov/react-components";
import { StepHeader } from "../components/Header/StepHeader";
import {
  getCurrentUrl,
  getLoginEndPoint,
} from "../../ServiceUtils/auth";
import FinishLaterConfirmation from "../components/Navigation/FinishLaterConfirmation";
import FinalConfirmation from "../components/Navigation/FinalConfirmation";
import ApplicationUpdatedConfirmation from "../components/Navigation/ApplicationUpdatedConfirmation";
import { specialSteps } from "../hooks/portalContextConstants";
import { useUnsavedChanges } from "../../MPP-Common-SPA/common/unsavedChangesContext";
import DynamicFormRenderer from "../../MPP-Common-SPA/components/DynamicForm/Forms/DynamicForm";
import StepActionButtons from "../components/Navigation/StepActionButtons";
import { setAnalyticsStepName } from "../../MPP-Common-SPA/utils/useAnalyticsStep";
import { useLogin } from "../hooks/useLogin";
import { getLoggedOutEndpoint } from "../../ServiceUtils/auth";

export const StepRenderer = (input) => {

  const {
    currentStep,
    getResourceValue,
    onPrevious,
    isLoggedIn,
    specialStep,
    getDynamicForm,
    supportInfo,
  } = input ?? {};

  const {
    title,
    renderer: { id, props } = {},
  } = currentStep ?? {};

  const pageTitle = getResourceValue({ key: title })

  const { clearDirty } = useUnsavedChanges();
  const { handleLogout } = useLogin();

  const { showBackButton, showStepCounter, requiresLogin } = props ?? {};

  const [userDataUpdated, setUserDataUpdated] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    setUserDataUpdated(false);
  }, [DynamicFormRenderer, specialStep]);

  useEffect(() => {
    if (requiresLogin && !isLoggedIn) {
      clearDirty();
      setTimeout(() => {
        window.location.href = getLoginEndPoint(getCurrentUrl());
      }, 0);
    }
  }, [requiresLogin, isLoggedIn]);

  // Update global analytics step name whenever current step changes for sign-in tracking
  useEffect(() => {
    if (currentStep?.name) {
      setAnalyticsStepName(currentStep.name);
    }
  }, [currentStep?.name]);

  if (specialStep === specialSteps.FinishLater) {
    return <FinishLaterConfirmation {...input} />;
  }

  if (specialStep === specialSteps.ApplicationSubmitted || specialStep === specialSteps.ApplicationWithdrawn) {
    return <FinalConfirmation {...input} />;
  }

  if (specialStep === specialSteps.ApplicationUpdated) {
    return <ApplicationUpdatedConfirmation {...input} />;
  }

  if (requiresLogin && !isLoggedIn) {
    return (
      <GoabPageBlock width="704px" data-testId="stepRenderer">
        <div style={{ margin: 40 }}>
          <h3>
            {getResourceValue({ key:
              "RESOURCES@global.redirectingToAlbertaAccountPage",
            }
            )}
          </h3>
        </div>
      </GoabPageBlock>
    );
  }

  if (!DynamicFormRenderer) {
    return (
      <GoabPageBlock width="704px" data-testId="stepRenderer">
        {showBackButton && showStepCounter && (
          <>
            <GoabSpacer vSpacing="2xl" />
            <GoabButton
              type="tertiary"
              onClick={onPrevious}
              size="compact"
              leadingIcon="chevron-back"
            >
              {getResourceValue({ key: "RESOURCES@global.button.back" })}
            </GoabButton>
          </>
        )}
        <h1>{pageTitle}</h1>
        <div>Renderer not found</div>
      </GoabPageBlock>
    );
  }

  return (
    <>
      <div id={currentStep.name} key={currentStep.name}>
        <StepHeader {...input} />
        {DynamicFormRenderer({
          ...input,
          props,
          isLoggedIn,
          dynamicForm: getDynamicForm(id),
          userDataUpdated,
          setUserDataUpdated,
          StepActionButtons,
          onProxySaveSuccess: () => handleLogout(getLoggedOutEndpoint),
          supportInfo,
        })}
      </div>
    </>
  );
};
